<h1>{{ "Slett gruppe"|translate }}</h1>
@if (!kanSletteGruppe()) {
  <div class="ikke-tilgang e2e-slett-gruppe-ikke-tilgang" >
    {{
      'Kun brukeren {epost} som er oppført som kontaktperson på avtalen {navn} kan slette denne gruppen.' |translate: {
        epost: avtale()?.kontaktperson.epost,
        navn: avtale()?.navn
      }
    }}
  </div>
} @else {
  <div class="last-ned">
    <div class="forklaring">
      {{ 'Hvis du ønsker å slette gruppen laster du ned tilhørende data fra  gruppen, for så å skrive inn en bekreftelseskode du får fra oss når du åpner filen (.zip). Nedlastning kan ta noen minutter.'|translate }}
    </div>
    <div class="knapp">
      <a mat-button mat-raised-button color="primary" (click)="lastNedKlikket()" class="e2e-last-ned-gruppe"
         href="{{url()}}" download="{{filnavn()}}">
        <mat-icon>download</mat-icon>
        {{ "Last ned data" | translate }}</a>
    </div>
  </div>
  <hr>
  <div class="bekreft" [ngClass]="{'grayout': !zipNedlastingErStartet()}">
    <!-- ingen [formGroup] da siden kun inneholder én formControl -->
    <form (ngSubmit)="slett()">
      <div class="forklaring">
        <h2>{{ 'Hvordan finne bekreftelseskoden?'|translate }}</h2>
        {{ 'Åpne filen du nettopp lastet ned til maskinen din ({filnavn}). Inne i filen finner du et dokument som inneholder bekreftelseskoden (bekreftelseskode.txt). Åpne dokumentet og skriv inn bekreftelseskoden:'|translate:{filnavn: filnavn()} }}
      </div>
      <div class="otp-label">{{ 'Skriv inn bekreftelseskoden du lastet ned '|translate }}
        <span class=fet>{{ zipNedlastetTidspunkt()|zoneddatetime }}</span>
      </div>
      <div class="otp">
        <div class="kode">
          <otp-felt [formControl]="otpKodeSkjema" [ugyldig]="otpValideringFeilet()"></otp-felt>
        </div>
        <div class="knapp">
          <button type="submit" mat-raised-button color="primary"
                  [disabled]="otpKodeSkjema.disabled || otpKodeSkjema.invalid || lagrer()">
            {{ 'Slett gruppe'|translate }}
          </button>
        </div>
      </div>
    </form>

    <div class="hjelp">
      <h2>{{ 'Finner du ikke bekreftelseskoden?'|translate }}</h2>
      <div [innerHTML]="'Ta kontakt med oss på tlf <a href=tel:+4740604475>406 04 475</a>, eller send oss en mail på <a href=mailto:post@styreplan.no>post@styreplan.no</a>' | translate"></div>
    </div>
  </div>
}

